import React, { useMemo, useState } from "react";
import { Skeleton, message } from "antd";
import { connect } from "dva";
import EditScanStatusModal from "./EditScanStatusModal";
import ScanStatusItem from "./ScanStatusItem";
import style from "./style.less";

const SCAN_TYPE = {
  PICKUP: "pickupScannedStatus",
  DROPOFF: "dropOffScannedStatus",
};

const ScanStatusList = ({ adminShipmentView, loading, dispatch, configPerm }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedScanType, setSelectedScanType] = useState(null);

  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView.data]);

  const editScanStatus = status => {
    const loadId = adminShipmentData?.load?.id;
    const shipmentId = adminShipmentData?.id;

    if (!loadId || !shipmentId) return;

    const data = {
      [selectedScanType]: status,
    };

    dispatch({
      type: "adminShipmentView/uploadScanStatus",
      loadId,
      shipmentId,
      data,
    }).then(result => {
      if (result?.error) {
        message.error("Error while updating scan status");
        return;
      }

      message.success("Scan status updated successfully");
      setIsEditOpen(false);
    });
  };

  const editPickupStatus = () => {
    setSelectedScanType(SCAN_TYPE.PICKUP);
    setIsEditOpen(true);
  };

  const editDropoffStatus = () => {
    setSelectedScanType(SCAN_TYPE.DROPOFF);
    setIsEditOpen(true);
  };

  const closeModal = () => {
    setIsEditOpen(false);
    setSelectedScanType(null);
  };

  if (loading) {
    return <Skeleton className={style.statusLoader} active title={false} paragraph={{ rows: 2, width: "100%" }} />;
  }

  return (
    <>
      {configPerm["CoreService.AdminShipments.ChangeScanStatus"] && (
        <>
          <ScanStatusItem
            title="Pickup scan status"
            status={adminShipmentData?.load?.pickupScannedStatus}
            onEdit={editPickupStatus}
          />
          <ScanStatusItem
            title="Dropoff scan status"
            status={adminShipmentData?.load?.dropOffScannedStatus}
            onEdit={editDropoffStatus}
          />
        </>
      )}

      <EditScanStatusModal
        isOpen={isEditOpen}
        title={`Edit ${selectedScanType === SCAN_TYPE.PICKUP ? "pickup" : "dropoff"} scan status`}
        status={adminShipmentData?.load?.[selectedScanType]}
        submitCallback={editScanStatus}
        cancelCallback={closeModal}
      />
    </>
  );
};

export default connect(({ adminShipmentView, loading, configs }) => ({
  adminShipmentView,
  loading: loading.effects["adminShipmentView/fetchSingleAdminShipment"],
  configPerm: configs.configPerm,
}))(ScanStatusList);
